import { type TerminalDefectsResponse } from '~/lib/types'

import { httpClientCustomer } from '../http-client-customer'

export async function getTerminalDefects() {
  return await httpClientCustomer<TerminalDefectsResponse>({ url: '/terminal-devices/defects' })
}
